import { parsePhoneNumber } from 'libphonenumber-js';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { isPossiblePhoneNumber } from 'libphonenumber-js';

export const formatNumber = (phone: string) => {
  return `${phone}`;
};

interface ValidationResult {
  isValid: boolean;
  errorMessage: string;
}

export const validatePhoneNumber = (value: string): ValidationResult => {
  if (!value) {
    return { isValid: false, errorMessage: 'Phone number is empty' };
  }

  const parsedPhoneNumber = parsePhoneNumber(value);

  if (!parsedPhoneNumber) {
    return { isValid: false, errorMessage: 'Unable to parse the phone number' };
  }

  const countryCode = parsedPhoneNumber.country;
  const maxLength = isPossiblePhoneNumber(parsedPhoneNumber.formatInternational(), countryCode);

  if (maxLength && isValidPhoneNumber(value)) {
    return { isValid: true, errorMessage: '' };
  } else {
    return { isValid: false, errorMessage: 'Please enter a valid phone number' };
  }
};
